import { CHART_SERIES_PALETTE } from '../theme/chartSeriesPalette';

export type ChartColorPalette = Readonly<{
  series: readonly string[];
}>;

export const CHART_COLOR_PALETTE: ChartColorPalette = {
  series: CHART_SERIES_PALETTE,
};
